import FontFamilyCommand from 'commands/fontFamilyCommand';
import FontSizeCommand from 'commands/fontSizeCommand';
import FontWeightCommand from 'commands/fontWeightCommand';
import FormatBlockCommand from 'commands/formatBlockCommand';
import LetterSpacingCommand from 'commands/letterSpacingCommand';
import StyleCommand from 'commands/styleCommand';
import _ from 'ckLodash';
import basicStyleCommands from 'commands/basicStyleCommands';
import editorDotWIX from 'namespace/editorDotWIX';
import experiments from 'utils/experiments';
import ieSpellCheckUtils from 'utils/ieSpellCheckUtils';
import inputEventHandler from 'eventHandlers/inputEventHandler';
import keyHandler from 'eventHandlers/keyHandler';
import lineHeightCmd from 'commands/lineHeightCommand';
import listCommand from 'commands/listCommand';
import placeholder from 'placeholder/placeholder';
import resetThemeCommand from 'commands/resetThemeCommand';
import resetThemesAndStylesCommand from 'commands/resetThemesAndStylesCommand';
import selectionChangeHandler from 'eventHandlers/selectionChangeHandler';
import toUpperCaseCommand from 'commands/toUpperCaseCommand';
import utils from 'utils/utils';
import verticalText from 'commands/verticalText';
import wixColorCommands from 'commands/wixColorCommands';
import wixCopy from 'wixPaste/wixCopy';
import wixCss from 'commands/wixCSS';
import wixLink from 'commands/wixLink';
import wixPaste from 'wixPaste/wixPaste';
import wixSelectLinks from 'commands/wixSelectLinks';
import wixSetHtmlCommand from 'commands/wixSetHtmlCommand';

function listenToCut(editor) {
    setTimeout(() => {
        if (editor && editor.editable()) {
            editor.editable().on('cut', () => {
                editor.fire('change');
                setTimeout(() => editor.getCommand('autogrow').exec(), 10);
            });
        } else {
            listenToCut(editor);
        }
    }, 50);
}

function execStyleWithCss(editor) {
    if (_.get(editor, 'document.$')) {
        if (utils.isIE()) {
            ieSpellCheckUtils.bindToSpellCheckEvents(editor);
        }

        editor.document.$.execCommand('styleWithCSS', true, null);
        return;
    }
    setTimeout(execStyleWithCss, 20);
}

function addCommands(editor) {
    editor.addCommand('font', new StyleCommand('span', 'font'));
    editor.addCommand('fontSize', new FontSizeCommand());
    editor.addCommand('fontFamily', new FontFamilyCommand());
    editor.addCommand('fontWeight', new FontWeightCommand());
    editor.addCommand('letterSpacing', new LetterSpacingCommand('span', 'letter-spacing'));
    editor.addCommand('textShadow', new StyleCommand('span', 'text-shadow'));
    editor.addCommand('formatBlock', new FormatBlockCommand('font_'));
    editor.addCommand('resetThemeAndStyles', resetThemesAndStylesCommand);
    editor.addCommand('resetTheme', resetThemeCommand);
    editor.addCommand('wixCss', wixCss());
    editor.addCommand('lineHeight', lineHeightCmd);
    editor.addCommand('toUpperCase', toUpperCaseCommand);
    editor.addCommand('wixSetHtml', wixSetHtmlCommand);
    editor.addCommand('wixSelectLinks', new wixSelectLinks());
    editor.addCommand('placeholder', placeholder);
}

function initCommands(editor) {
    verticalText.init(editor);
    listCommand.init(editor);
    wixLink.init(editor);
    wixPaste.init(editor);
    wixCopy.init(editor);
    keyHandler.init(editor);
    selectionChangeHandler.init(editor);
    basicStyleCommands.initUnBold(editor);
    basicStyleCommands.initUnItalic(editor);
    wixColorCommands.initForeColorCommand(editor);
    wixColorCommands.initBackColorCommand(editor);
}

//todo: we want to enable the following commands to affect lists: italic, bold, forecolor, theme, fontsize, fontfamily
CKEDITOR.WIX.status = 'ready';

CKEDITOR.on('instanceReady', function (evt) {
    const editor = evt.editor;
    execStyleWithCss(editor);
    listenToCut(editor);
    experiments.init(editor.config.isExperimentOpen);
    const body = editor.document.getBody();
    body.addClass('non-letter-spacing-reset');
});

CKEDITOR.on('instanceLoaded', function (evt) {
    const editor = evt.editor;
    editor.config.disableNativeSpellChecker = false;
    inputEventHandler.init(editor);
    editorDotWIX.init(editor);
    editor.container.hide();
    addCommands(editor);
    initCommands(editor);

    //cause issues in Santa Editor, besides why do focus when selecting text...
    editor.getCommand('selectAll').editorFocus = false;

    editor.attachStyleStateChange(editor.getCommand('bold').style, function () {
        var boldState = editor.getCommand('bold').state;
        if (boldState !== CKEDITOR.TRISTATE_DISABLED) {
            var fontWeight = editor.getCommand('fontWeight').state;
            var weight = _.parseInt(fontWeight, 10);
            if (utils.isValidFontWeight(weight)) {
                if (weight >= 700) {
                    editor.getCommand('bold').setState(CKEDITOR.TRISTATE_ON);
                } else {
                    editor.getCommand('unBold').setState(CKEDITOR.TRISTATE_ON);
                }
            }
        }
    });
});
